<script>
import CategoriesTabPage from '@/pages/blogs/categories/Categories-tab-page.vue';
import ArticlesTabPage from '@/pages/blogs/articles/Articles-tab-page.vue';

export default {
  components: { ArticlesTabPage, CategoriesTabPage },
};
</script>

<template>
  <div v-if="this.$route.params.type === 'categories'">
    <categories-tab-page />
  </div>
  <div v-else-if="this.$route.params.type === 'articles'">
    <articles-tab-page />
  </div>
</template>
